import React, { useEffect, useMemo, useState } from "react";
import {
  Avatar,
  Card,
  Col,
  Flex,
  List,
  Row,
  Select,
  Table,
  Tag,
  Typography,
} from "antd";
import { useNavigate } from "react-router-dom";
import Title from "antd/es/typography/Title";
import { baseRouteMaker, routes } from "../../../../../constants/routeConsts";
import { colors } from "../../../../../constants/colors";
import {
  CustomersIcon,
  RCustomersIcon,
  
  DAppointmentIcon,
  RDAppointmentIcon,

  DInvoiceIcon,
  RDInvoiceIcon,

  DPatientIcon,
  RDPatientIcon,

  DStaffIcon,
  RDStaffIcon,
  RDOrderIcon,
  DecrementalArrowIcon,
  IncrementalArrowIcon,
} from "../../../../../assets/svg";
import { GetCardLayout } from "../../../../common/getCardLayout";
import ReactApexChart from "react-apexcharts";
import styles from "./Dashboard.module.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  getServiceProviderDashboardIndexAction,
  getServiceProviderDashboardOrderMetricsAction,
  getServiceProviderDashboardSalesMetricsAction,
} from "../../../../../redux/services/service-provider-dashboard/serviceProviderDashboardServices";
import { getStaffAction } from "../../../../../redux/services/staff/staffServices";
import { appConfig } from "../../../../../constants/config/appConfig";
import { appAssetsConfig } from "../../../../../constants/config/appAssetsConfig";
import { getServiceProviderAppointmentsAction } from "../../../../../redux/services/service-provider-appointments/serviceProviderAppointmentsServices";
import {
  dateObjToDispViewDate,
  timeObjToDispViewTimeWithSuffix,
} from "../../../../../utils/utils";
import dayjs from "dayjs";
import Spinner from "../../../../common/spinner/Spinner";
import { useTranslation } from "react-i18next";
import Actions from "../../../../../redux/actions";
import { UserOutlined } from "@ant-design/icons";

const Dashboard = () => {
  const { t } = useTranslation();
  /* navigation dependencies */
  const navigate = useNavigate();
  /* navigation dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  const [loadingComponent, setLoadingComponent] = useState(false);
  /* loading dependencies */

  /* table dependencies */
  const { serviceProviderDashboardIndex } = useSelector(
    (state) => state.serviceProviderDashboard
  );
  const [dashboardCountPercentages,setDashboardCountPercentages] = useState({})
  /* table dependencies */

  /* chart data - section 2*/

  const isOrgVerified = useSelector(
    (state) => state?.auth?.loginDetails?.organization_id?.organization_verified
  );

  const openVerificationDialog = () => {
    dispatch(Actions.createAction(Actions.VERIFIED_DIALOG_OPEN));
  };

  const [donutChartSeries, setDonutChartSeries] = useState([]);
  const [donutChartOrderMetricsData, setDonutChartOrderMetricsData] = useState({
    options: {
      labels: [],
      colors: [],
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              total: {
                show: true,
                fontSize: "14px",
                fontWeight: 500,
              },
            },
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: true,
        position: "bottom",
        fontSize: "14px",
        fontFamily: "Poppins",
        markers: {
          radius: 12,
        },
        itemMargin: {
          horizontal: 20,
          vertical: 0,
        },
      },
    },
    series: [],
  });
  const [orderEarningsData, setOrderEarningsData] = useState({});
  const [barChartOrderProfitMetricsData, setBarChartOrderProfitMetricsData] =
    useState({
      series: [],
      options: {
        chart: {
          type: "line",
          height: 440,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: true,
          position: "top",
          horizontalAlign: "right",
          fontSize: "12px",
          fontFamily: "Poppins",
          markers: {
            radius: 12,
          },
          itemMargin: {
            horizontal: 20,
            vertical: 0,
          },
        },
        xaxis: {
          categories: [
            t("CommonUtils.today"),
            t("CommonUtils.yesterday"),
            t("CommonUtils.last7Days"),
            t("CommonUtils.last15Days"),
            t("CommonUtils.last30Days"),
            t("CommonUtils.thisMonth")
          ],

          labels: {
            style: {
              colors: [...Array(6)].map(() => colors.slateBlue),
              fontSize: "12px",
              fontFamily: "Poppins",
            },
          },
        },
        yaxis: {
          labels: {
            style: {
              colors: [...Array(6)].map(() => colors.slateBlue),
              fontSize: "12px",
              fontFamily: "Poppins",
            },
          },
        },
        colors: [colors.DarkMint, colors.indigo],
      },
    });
    const [consultationStatusData, setConsultationStatusData] = useState({
      series: [
        {
          name: "Cancelled",
          // data: [44],
          data: [44, 55, 57, 56, 61, 58, 63, 60, 66, 34, 10, 57],
        },
        {
          name: "Completed",
          data: [76, 85, 101, 98, 87, 105, 91, 114, 94, 150, 120, 89],
        },
      ],
      options: {
        chart: {
          type: "bar",
          height: 440,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: true,
          position: "top",
          horizontalAlign: "right",
          fontSize: "16px",
          fontFamily: "Poppins",
          markers: {
            radius: 12,
          },
          itemMargin: {
            horizontal: 20,
            vertical: 0,
          },
        },
        xaxis: {
          categories: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ],
          labels: {
            style: {
              colors: [...Array(12)].map(() => colors.slateBlue),
              fontSize: "16px",
              fontFamily: "Poppins",
            },
          },
        },
        yaxis: {
          labels: {
            style: {
              colors: [...Array(12)].map(() => colors.slateBlue),
              fontSize: "16px",
              fontFamily: "Poppins",
            },
          },
        },
        colors: [colors.crimson, colors.indigo],
      },
    })
  const [orderCount, setOrderCount] = useState({});
  const [orderProfit, setOrderProfit] = useState({});
  /* chart data - section 2*/

  /* chart data - section 3*/
  const [topSalesByAppointmentTypeData, setTopSalesByAppointmentTypeData] =
    useState({});
  const [
    donutChartTopSalesByAppointmentTypeData,
    setDonutChartTopSalesByAppointmentTypeData,
  ] = useState({
    options: {
      labels: [],
      colors: [],
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              total: {
                show: true,
                fontSize: "14px",
                fontWeight: 500,
              },
            },
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: true,
        position: "bottom",
        fontSize: "14px",
        fontFamily: "Poppins",
        markers: {
          radius: 12,
        },
        itemMargin: {
          horizontal: 20,
          vertical: 0,
        },
      },
    },
    series: [],
  });
  const [topServiceProviders, setTopServiceProviders] = useState([]);
  const [topCustomers, setTopCustomers] = useState([]);
  const { staffs } = useSelector((state) => state.staff);
  const { serviceProviderAppointmentsInfo } = useSelector(
    (state) => state.serviceProviderAppointments
  );
  /* chart data - section 3*/

  /* setting chart series and data - Section 2 */
  useEffect(() => {
    donutChartSeries &&
      donutChartSeries[0] &&
      donutChartSeries[0]?.length !== 0 &&
      setDonutChartOrderMetricsData((prevValue) => {
        return {
          options: {
            ...prevValue.options,
            labels: [t("CommonUtils.completed"), t("CommonUtils.incomplete"), t("CommonUtils.ongoing"), t("CommonUtils.pending"), t("CommonUtils.cancelled"), t("CommonUtils.rejected")],
            colors: [colors.DarkMint, colors.limeGreen, colors.indigo, colors.blue, colors.crimson, colors.turquoise],
          },
          series: donutChartSeries[0],
        };
      });
  }, [donutChartSeries]);

  useEffect(() => {
    orderEarningsData &&
      orderEarningsData?.orderProfit &&
      orderEarningsData?.orderSales &&
      setBarChartOrderProfitMetricsData((prevValue) => {
        return {
          series: [
            {
              name: t("CommonUtils.orderProfit"),
              data: orderEarningsData?.orderProfit,
            },
            {
              name: t("CommonUtils.orderSales"),
              data: orderEarningsData?.orderSales,
            },
          ],
          options: {
            ...prevValue.options,
          },
        };
      });
  }, [orderEarningsData]);

  useEffect(() => {
    if (
      topSalesByAppointmentTypeData &&
      topSalesByAppointmentTypeData?.topSalesByAppointmentTypeDataArr &&
      topSalesByAppointmentTypeData?.topSalesByAppointmentTypeSalesArr
    ) {
      setDonutChartTopSalesByAppointmentTypeData((prevValue) => {
        return {
          options: {
            ...prevValue.options,
            labels:
              topSalesByAppointmentTypeData?.topSalesByAppointmentTypeDataArr,
            colors: [colors.teal, colors.indigo],
          },
          series:
            topSalesByAppointmentTypeData?.topSalesByAppointmentTypeSalesArr,
        };
      });
    }
  }, [topSalesByAppointmentTypeData]);
  /* setting chart series and data - Section 2 */

  const handleGetTableData = () => {
    /* section 1 */
    dispatch(getServiceProviderDashboardIndexAction(setLoadingComponent));
    /* section 1 */

    /* section 2 */
    dispatch(
      getServiceProviderDashboardOrderMetricsAction(setLoadingComponent)
    ).then((apiRes) => {
      // const resp = apiRes?.month_wise_count?.map((element)=>[
      //   element.completed.reduce((accumulator, item) => {...accumulator},{}),
      // ])
      const resp = apiRes?.month_wise_count?.map((entry) => {
        const dynamicKey = Object.keys(entry)[0];
    
        if (entry[dynamicKey].length > 0) {
          const dynamicEntry = entry[dynamicKey][0];
    
          return {
            name: dynamicKey.charAt(0).toUpperCase() + dynamicKey.slice(1),
            data: [dynamicEntry.orders]
          };
        }
    
        return null;
      }).filter(Boolean);

      setDonutChartSeries(
        apiRes?.month_wise_count?.map((item) => [
          item.completed.reduce(
            (totalSales, order) => totalSales + order.orders,
            0
          ),
          item.incomplete.reduce(
            (totalSales, order) => totalSales + order.orders,
            0
          ),
          item.ongoing.reduce(
            (totalSales, order) => totalSales + order.orders,
            0
          ),
          item.pending.reduce(
            (totalSales, order) => totalSales + order.orders,
            0
          ),
          item.cancelled.reduce(
            (totalSales, order) => totalSales + order.orders,
            0
          ),
          item.rejected.reduce(
            (totalSales, order) => totalSales + order.orders,
            0
          ),
        ])
      );
    });

    dispatch(
      getServiceProviderDashboardSalesMetricsAction(setLoadingComponent)
    ).then((apiRes) => {
      const orderProfit =
        apiRes?.order_profit &&
        Object.entries(apiRes?.order_profit)?.reduce(
          (accumulator, [key, value]) => {
            !["this_month_last_month", "last_month"].includes(key) &&
              accumulator.push(value);
            return accumulator;
          },
          []
        );
      const orderSales =
        apiRes?.order_sales &&
        Object.entries(apiRes?.order_sales)?.reduce(
          (accumulator, [key, value]) => {
            !["this_month_last_month", "last_month"].includes(key) &&
              accumulator.push(value);
            return accumulator;
          },
          []
        );
      setOrderCount(apiRes?.order_count);
      setOrderProfit(apiRes?.order_profit);
      const {customer_count,order_type_offer_order_count, order_type_package_order_count, order_type_service_order_count, order_type_service_provider_order_count} = apiRes;
      setDashboardCountPercentages({
        customer_count,order_type_offer_order_count, order_type_package_order_count, order_type_service_order_count, order_type_service_provider_order_count
      })
      setOrderEarningsData({ orderProfit, orderSales });

      const appointmentModes = {
        IN_PERSON: "In person",
        VIDEO_CALL: "Video call",
      };

      const topSalesByAppointmentTypeDataArr = apiRes?.sales_by_appointment_mode
        ?.filter((elem) => elem._id !== "NONE")
        ?.map((element) => {
          return appointmentModes[element?._id];
        });
      const topSalesByAppointmentTypeSalesArr =
        apiRes?.sales_by_appointment_mode
          ?.filter((elem) => elem._id !== "NONE")
          ?.map((element) => {
            return Math.round(element?.sales) || 0;
          });

      setTopSalesByAppointmentTypeData({
        topSalesByAppointmentTypeDataArr,
        topSalesByAppointmentTypeSalesArr,
      });

      setTopServiceProviders(apiRes?.top_n_services);

      setTopCustomers(apiRes?.top_n_customer);

      dispatch(getStaffAction({},setLoading));

      const dataToBeSent = { page: 1, limit: 500, time_unit: "THIS_WEEK" };
      dispatch(getServiceProviderAppointmentsAction(dataToBeSent, setLoading));
    });
    /* section 2 */
  };

  useEffect(() => {
    handleGetTableData();
  }, []);

  /* Cards component - Section 1 */
  const CardComponent = () => {
    const dashoardIndexMetrics = {
      Staff: {
        // icon: <DStaffIcon/>,
        icon: <RDStaffIcon/>,
        backgroundColor: colors.darkBlue,
        countPercentage : dashboardCountPercentages?.order_type_service_provider_order_count
      },
      Customers: {
        icon: <RDPatientIcon />,
        // icon: <DPatientIcon />,
        backgroundColor: colors.lightCoral,
        countPercentage : dashboardCountPercentages?.customer_count
      },
      Offers: {
        icon: <RDInvoiceIcon />,
        // icon: <DInvoiceIcon />,
        backgroundColor: colors.lightGreen,
        countPercentage : dashboardCountPercentages?.order_type_offer_order_count
      },
      Packages: {
        icon: <RCustomersIcon fillColor={colors.crimson} />,
        // icon: <CustomersIcon fillColor={colors.crimson} />,
        backgroundColor: colors.crimson,
        countPercentage : dashboardCountPercentages?.order_type_package_order_count
      },
      Services: {
        
        icon: <RDAppointmentIcon />,
        // icon: <DAppointmentIcon />,
        backgroundColor: colors.oceanBlue,
        countPercentage : dashboardCountPercentages?.order_type_service_order_count
      },
    };
    return (
      <>
        <>
          {serviceProviderDashboardIndex?.map((item, index) => (
            <Col xs={24} sm={12} md={8} lg={8} key={index}>
              <Card
                hoverable
                style={{
                  backgroundColor:
                   colors.white,
                  borderRadius: "20px",
                }}
              >
                <div style={{display:'flex',
                  justifyContent:'flex-end'
                }}>
                <Flex
                    align="center"
                    gap="0.5rem"
                    style={{
                      background: colors.lightMint,
                      width: "fit-content",
                      borderRadius: "0.2rem",
                      padding: "0.1rem 0.5rem",
                      marginBottom:'1rem'
                     
                    }}
                  >
                    {dashoardIndexMetrics[item?.key]?.countPercentage?.this_month_last_month?.split(" ")[1] ===
                    "up" ? (
                      <IncrementalArrowIcon />
                    ) : (
                      <DecrementalArrowIcon />
                    )}
                    <Title level={5} style={{ margin: 0,color:colors.DarkMint , fontWeight:'normal'}}>
                      <span
                        style={{
                          fontWeight:'bold',
                          color:
                          dashoardIndexMetrics[item?.key]?.countPercentage?.this_month_last_month?.split(" ")[1] ===
                            "up"
                              ? colors.DarkMint
                              : colors.DarkMint,
                        }}
                      >
                        {dashoardIndexMetrics[item?.key]?.countPercentage?.this_month_last_month?.split(" ")[0]}
                      </span>{" "}
                     {t(`dashboard.thanLastMonth`)}
                    </Title>
                  </Flex>
                </div>
                 


                <Flex gap="1rem">
                  {dashoardIndexMetrics[item?.key]?.icon}
                  <Flex vertical>
                    <Title level={4} style={{ color: colors.darkGrey }}>
                      {t(`dashboard.${item?.key}`)}
                    </Title>
                    <Title level={1} style={{ margin: 0, color: colors.black }}>
                      {item?.value}
                    </Title>
                   
                  </Flex>
                </Flex>
                
              </Card>
            </Col>
          ))}
          <Col xs={24} sm={12} md={8} lg={8}>
            <Card
              hoverable
              style={{
                backgroundColor: colors.white,
                borderRadius: "20px",
              }}
            >
            <div style={{display:'flex',
                  justifyContent:'flex-end'
                }}>
                     <Flex
                    align="center"
                    gap="0.5rem"
                    style={{
                      background: colors.lightMint,
                      width: "fit-content",
                      borderRadius: "0.2rem",
                      padding: "0.1rem 0.5rem",
                      marginBottom:'1rem'
                    }}
                  >
                    {orderCount?.this_month_last_month?.split(" ")[1] ===
                    "up" ? (
                      <IncrementalArrowIcon />
                    ) : (
                      <DecrementalArrowIcon />
                    )}
                    <Title level={5} style={{margin: 0,color:colors.DarkMint , fontWeight:'normal' }}>
                      <span
                        style={{
                          fontWeight:'bold',
                          color:
                            orderCount?.this_month_last_month?.split(" ")[1] ===
                            "up"
                            ? colors.DarkMint
                            : colors.DarkMint,
                        }}
                      >
                        {orderCount?.this_month_last_month?.split(" ")[0]}
                      </span>{" "}
                      {t(`dashboard.thanLastMonth`)}
                    </Title>
                  </Flex>

              </div>
              <Flex gap="1rem">
                <RDOrderIcon fillColor={colors.teal} />
                <Flex vertical>
                  <Title level={4} style={{ color: colors.darkGrey  }}>
                    {t(`dashboard.Orders`)}
                  </Title>
                  <Title level={1} style={{ margin: 0, color: colors.black }}>
                    {orderCount?.total}
                  </Title>
               
                </Flex>
              </Flex>
            </Card>
          </Col>
        </>
      </>
    );
  };
  /* Cards component - Section 1 */

  /* Appointments And Earnings Component - Section 2 */
  const AppointmentsAndEarningsComponent = () => {
    return (
      <>
        <Col span={16}>
          <GetCardLayout style={{ height: "450px" }}>
            <Flex gap="1rem" vertical>
              <Typography.Title level={2}>
                {" "}
                {t(`dashboard.orders_earning`)}
              </Typography.Title>
              {barChartOrderProfitMetricsData?.series &&
                barChartOrderProfitMetricsData?.series?.length > 0 && (
                  <ReactApexChart
                    type="line"
                    height={360}
                    options={barChartOrderProfitMetricsData?.options}
                    series={barChartOrderProfitMetricsData?.series}
                  />
                )}
            </Flex>
          </GetCardLayout>
          {/* <GetCardLayout style={{ height: "530px" }}>
              <Flex gap="1rem" vertical>
                <Typography.Title level={2}>
                  Consultation Status
                </Typography.Title>
                
                  <ReactApexChart
                    type="bar"
                    height={440}
                    options={consultationStatusData?.options}
                    series={consultationStatusData?.series}
                  />
              </Flex>
            </GetCardLayout> */}
        </Col>

        <Col span={8}>
          <GetCardLayout style={{ height: "450px" }}>
            <Flex gap="1rem" vertical align="center" justify="center">
              <Typography.Title level={2}>
                {t(`dashboard.Orders`)}
              </Typography.Title>
              {donutChartOrderMetricsData?.series &&
                donutChartOrderMetricsData?.series?.length > 0 && (
                  <ReactApexChart
                    type="donut"
                    width={250}
                    height={360}
                    options={donutChartOrderMetricsData?.options}
                    series={donutChartOrderMetricsData?.series}
                  />
                )}
            </Flex>
          </GetCardLayout>
        </Col>
      </>
    );
  };
  /* Appointments And Earnings Component - Section 2 */

  /* Sales By Appointment Mode, Top Service Providers and Top Customers - Section 3 */
  const SalesByAppointmentModeTopServiceProvidersAndTopCustomers = () => {
    return (
      <>
        <Col span={8}>
          <GetCardLayout style={{ height: "450px" }}>
            <Flex gap="1rem" vertical align="center" justify="center">
              <Typography.Title level={2}>
                {t(`dashboard.salesByAppointmentMode`)}
              </Typography.Title>
              {donutChartTopSalesByAppointmentTypeData?.series &&
                donutChartTopSalesByAppointmentTypeData?.series?.length > 0 && (
                  <ReactApexChart
                    type="donut"
                    width={250}
                    height={360}
                    options={donutChartTopSalesByAppointmentTypeData?.options}
                    series={donutChartTopSalesByAppointmentTypeData?.series}
                  />
                )}
            </Flex>
          </GetCardLayout>
        </Col>
        <Col span={8}>
          <GetCardLayout style={{ height: "450px" }}>
            <Flex vertical gap="1rem" justify="space-around">
              <Typography.Title level={2}>
                {t(`dashboard.topServices`)}
              </Typography.Title>
              <div
                style={{
                  height: 350,
                  overflow: "auto",
                }}
              >
                <List
                  dataSource={topServiceProviders}
                  renderItem={(item) => (
                    <List.Item key={item._id}>
                      <List.Item.Meta
                        style={{ alignItems: "center" }}
                        title={
                          <Flex justify="space-between">
                            <Title type="secondary" level={3}>
                              {item.service_name}
                            </Title>
                            <Tag
                              bordered={false}
                              style={{
                                background: colors.darkSearGreen,
                                color: colors.limeGreen,
                              }}
                            >
                              {item.sales}
                            </Tag>
                          </Flex>
                        }
                      />
                    </List.Item>
                  )}
                />
              </div>
            </Flex>
          </GetCardLayout>
        </Col>
        <Col span={8}>
          <GetCardLayout style={{ height: "450px" }}>
            <Flex vertical gap="1rem" justify="space-around">
              <Typography.Title level={2}>
                {t(`dashboard.topCustomer`)}
              </Typography.Title>
              <div
                style={{
                  height: 350,
                  overflow: "auto",
                }}
              >
                <List
                  dataSource={topCustomers}
                  renderItem={(item) => (
                    <List.Item key={item._id}>
                      <List.Item.Meta
                        style={{ alignItems: "center" }}
                        title={
                          <Flex justify="space-between">
                            <Title type="secondary" level={3}>
                              {item.customer_name}
                            </Title>
                            <Tag
                              bordered={false}
                              style={{
                                background: colors.slatePurple,
                                color: colors.indigo,
                              }}
                            >
                              {item.revenue}
                            </Tag>
                          </Flex>
                        }
                      />
                    </List.Item>
                  )}
                />
              </div>
            </Flex>
          </GetCardLayout>
        </Col>
      </>
    );
  };

  /* Sales By Appointment Mode, Top Service Providers and Top Customers - Section 3 */

  /* Staff And Invoices Component - Section 4 */
  const StaffAndInvoicesComponent = () => {
    const tempTableColumns = [
      {
        title: t(`dashboard.customerName`),
        key: "name",
        render: (_, record) => {
          return (
            <Flex gap="1rem" align="center">
              <Avatar
                src={record?.user?.profile_image}
                key={record?.user?._id}
                icon={<UserOutlined />}
              />
              {`${record?.user?.first_name} ${record?.user?.last_name}`}
            </Flex>
          );
        },
      },
      {
        title: t(`dashboard.appointmentDate`),
        dataIndex: "appointment_date",
        key: "appointment_date",
        render: (_, record) => (
          <p>{dateObjToDispViewDate(record?.appointment_date, "ddmmyyyy")}</p>
        ),
      },
      {
        title: t(`dashboard.appointmentTime`),
        dataIndex: "appointment_date_time",
        key: "appointment_date_time",
        render: (_, record) => (
          <p>
            {timeObjToDispViewTimeWithSuffix(
              dayjs(record?.appointment_date_time)
                .subtract(
                  dayjs(record?.appointment_date_time).utcOffset(),
                  "minute"
                )
                .format("YYYY-MM-DDTHH:mm:ss")
            )}
          </p>
        ),
      },
      {
        title: t(`dashboard.appointmentMode`),
        dataIndex: "appointment_mode",
        key: "appointment_mode",
      },

      {
        title: t(`dashboard.status`),
        key: "is_payment_completed",
        dataIndex: "is_payment_completed",
        render: (_, { is_payment_completed }) => (
          <>
            <Tag
              bordered={false}
              style={{
                background: is_payment_completed
                  ? colors.lightTeal
                  : colors.lightPinkishRed,
                color: is_payment_completed
                  ? colors.darkTeal
                  : colors.darkMaroon,
              }}
            >
              {is_payment_completed ? t("Modules.Appointments.paid") : t("Modules.Appointments.due")}
            </Tag>
          </>
        ),
      },
      {
        title: t(`dashboard.charges`),
        dataIndex: "total_amount",
        key: "total_amount",
        render: (_, record) => (
          <p>{record?.total_amount ? record?.total_amount?.toFixed(2) : "-"}</p>
        ),
      },
    ];

    return (
      <>
        <Col span={8}>
          <GetCardLayout style={{ height: "450px" }}>
            <Flex vertical gap="1rem" justify="space-around">
              <Flex justify="space-between">
                <Typography.Title level={2}>
                  {t(`dashboard.Staff`)}
                </Typography.Title>
                <Typography.Link
                  level={4}
                  style={{ margin: 0 }}
                  onClick={() =>
                    {
                      isOrgVerified ? navigate(baseRouteMaker(routes.CREATE_STAFF)) : openVerificationDialog()
                      dispatch(Actions.createAction(Actions.SELECTED_STAFF_ID, { selectedStaffId: "" }));
                    }
                  }
                >
                  {t(`dashboard.addNewStaff`)}
                </Typography.Link>
              </Flex>
              <div
                style={{
                  height: 370,
                  overflow: "auto",
                }}
              >
                <List
                  dataSource={staffs?.data}
                  renderItem={(item) => (
                    <List.Item key={item._id}>
                      <List.Item.Meta
                        style={{ alignItems: "center" }}
                        avatar={
                          <Avatar
                            src={item.profile_image}
                            key={item._id}
                            icon={<UserOutlined />}
                          />
                        }
                        title={
                          <Flex justify="space-between">
                            <Title type="secondary" level={3}>
                              {`${item.first_name} ${item.last_name}`}
                            </Title>
                            <Tag
                            style={{borderRadius:10}}
                              color={
                                item?.status === "active" ? colors.green : '#CB3A31'
                              }
                              
                              key={item?._id}
                            >
                              {item?.status === "active"
                                ? "AVAILABLE"
                                : "NOT AVAILABLE"}
                            </Tag>
                          </Flex>
                        }
                      />
                    </List.Item>
                  )}
                />
              </div>
            </Flex>
          </GetCardLayout>
        </Col>

        <Col span={16}>
          <GetCardLayout style={{ height: "450px" }}>
            <Flex gap="1rem" vertical>
              <Flex justify="space-between" align="center">
                <Typography.Title level={2}>
                  {t(`dashboard.appointment`)}
                </Typography.Title>
              </Flex>
              <Table
                dataSource={serviceProviderAppointmentsInfo?.data}
                columns={tempTableColumns}
                pagination={false}
                style={{ overflow: "auto", height: 370 }}
              />
            </Flex>
          </GetCardLayout>
        </Col>
      </>
    );
  };
  /* Staff And Invoices Component - Section 4 */

  return (
    <>
      <div className={styles.dashboardMainContainer}>
        {loading ? (
          <Spinner />
        ) : (
          <Row gutter={[16, 16]}>
            <CardComponent />
            <AppointmentsAndEarningsComponent />
            <SalesByAppointmentModeTopServiceProvidersAndTopCustomers />
            <StaffAndInvoicesComponent />
          </Row>
        )}
      </div>
    </>
  );
};

export default Dashboard;
